import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import { translate } from 'react-i18next';
import rules from '../../../common/rules/rules';
import accountRules from '../../../common/rules/accountRules';
import { adminRolesT } from '../../../common/enums';
import Select from 'antd/lib/select';

const { Item } = Form;
const { Option } = Select;

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },
};

const tailFormItemLayout = {
  wrapperCol: {
    span: 14,
    offset: 6,
  },
};

@translate()
@Form.create()
export default class AdministratorCreateForm extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    form: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
  };

  handleSubmit = e => {
    e.preventDefault();

    const { form, onSubmit } = this.props;

    form.validateFields((err, values) => {
      if (!err) {
        onSubmit(values);
      }
    });
  };

  render() {
    const { t } = this.props;
    const { getFieldDecorator } = this.props.form;

    return (
      <Form onSubmit={this.handleSubmit}>
        <h1>{t('Nový administrátor')}</h1>

        <div className="padded">
          <Item {...formItemLayout} label={t('Meno')}>
            {getFieldDecorator('nameFirst', { rules: rules.required })(
              <Input size="default" placeholder={t('Meno')} autoFocus />
            )}
          </Item>

          <Item {...formItemLayout} label={t('Priezvisko')}>
            {getFieldDecorator('nameLast', { rules: rules.required })(
              <Input size="default" placeholder={t('Priezvisko')} />
            )}
          </Item>

          <Item {...formItemLayout} label={t('E-mail')}>
            {getFieldDecorator('email', { rules: rules.emailRequired })(
              <Input size="default" placeholder={t('E-mail')} type="email" />
            )}
          </Item>

          <Item {...formItemLayout} label={t('Heslo')}>
            {getFieldDecorator('password', { rules: [
              rules.required,
              ...accountRules.passwordWithLimit,
              ] })(
              <Input size="default" placeholder={t('Heslo')} />
            )}
          </Item>

          <Item {...formItemLayout} label={t('Rola')}>
            {getFieldDecorator('role', { rules: rules.required })(
              <Select size="default" placeholder={t('Vybrať rolu')}>
                {Object.entries(adminRolesT).map(([key, value]) => (
                  <Option key={key} value={key}>
                    {value}
                  </Option>
                ))}
              </Select>
            )}
          </Item>

          <Item {...tailFormItemLayout}>
            <Button type="primary" size="default" htmlType="submit">
              {t('Uložiť')}
            </Button>
          </Item>
        </div>
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/administrator-management/components/AdministratorCreateForm.js